import parseResponse from './parse-response';
// Error handler for APIs which adhere to the API styleguide spec. In the spec
// APIs still return a response message for non-200 status codes. This response
// message contains an array of connect Error objects.
export default class ConnectError extends Error {
    constructor(response, protoMessage, message) {
        super();
        this.message = ConnectError.generateMessage(response, protoMessage, message);
        this.protoMessage = protoMessage;
        this.rawResponse = response;
    }
    static generateMessage(response, protoMessage, message) {
        if (protoMessage && protoMessage.errors) {
            const errorCount = protoMessage.errors && protoMessage.errors.length > 0;
            return `response failed for ${response.url} (status=${response.status} ${response.statusText}): protoResponse includes ${errorCount} errors`;
        }
        else {
            return `response failed for ${response.url} (status=${response.status} ${response.statusText}): ${message}`;
        }
    }
    static fromResponse(response, rpcMethod) {
        if (response.status < 400) {
            return new Promise((resolve) => resolve(response));
        }
        if (response.headers.get('content-type') === 'application/x-protobuf') {
            return parseResponse(response).then((responseData) => {
                let protoMessage = null;
                try {
                    protoMessage = rpcMethod.decode(responseData);
                }
                catch (error) {
                    throw new ConnectError(response, null, String(error));
                }
                throw new ConnectError(response, protoMessage, null);
            });
        }
        else {
            return response.text().then((text) => {
                throw new ConnectError(response, null, text);
            });
        }
    }
}
